var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignOutIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 18.3594C15.5483 20.2884 13.9407 21.9265 11.7871 21.8737C11.286 21.8615 10.6668 21.6869 9.42825 21.3375C6.44751 20.4967 3.85995 19.0836 3.23913 15.9182C3.125 15.3365 3.125 14.6817 3.125 13.3722V11.6278C3.125 10.3183 3.125 9.66359 3.23913 9.08173C3.85995 5.9163 6.44751 4.50329 9.42825 3.66253C10.6668 3.31316 11.286 3.13849 11.7871 3.12624C13.9407 3.07355 15.5483 4.71153 15.625 6.64063",
    stroke: "#5754E5",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8763 12.5002H10.418M21.8763 12.5002C21.8763 11.7708 19.7989 10.408 19.2721 9.896M21.8763 12.5002C21.8763 13.2295 19.7989 14.5924 19.2721 15.1043",
    stroke: "#5754E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOutIcon);
export default __webpack_public_path__ + "static/media/SignOutIcon.fd0119b31fcf749cbb0982ceb2200156.svg";
export { ForwardRef as ReactComponent };